import React, { useContext, useState } from 'react'
import carIcon from '../../../assets/icons/car-black-bk-gray-icon.svg';
import equipmentIcon from '../../../assets/equipment-tools-access-icon.svg';
import visitIcon from '../../../assets/icons/visit-blue-bk-blue-icon.svg'
import empIcon from '../../../assets/icons/emp-black-bk-gray-icon.svg';
import { getDateOrTimeToReport } from '../entryAndDepartureHelper';
import { t } from 'i18next';
import EntryAndDepartureReportContext from '../../../context/EntryAndDepartureReportContext/EntryAndDepartureReportContext';
import { Spinner } from 'reactstrap';
import { useKeyByWord } from '../../../customHooks/useKyByWord';
import { colorAptitude, getDataUserByKey, getTenantInfoByKey, getUserBuilding, havePermission, isoToDate } from '../../../helpers/helpers';
import errorIcon from '../../../assets/icons/xmark-red-icon.svg';
import { Alert } from 'reactstrap';
import { CustomDateInput } from '../../CustomDateInput/CustomDateInput';
import { CustomTooltip } from '../../CustomTooltip/CustomTooltip';
import useGetDateAndHour from '../../../customHooks/useGetDateAndHour';

export const EntryOrDepartureDetail = ({ type, resourceType, setEdited }) => {

    const translationHook = useKeyByWord;
    const translationApt = (typeKey, key) => translationHook(typeKey, key);

    const { entryAndDepartureReportState, editEntryOrDeparture, getEntriesAndDepartures } = useContext(EntryAndDepartureReportContext);
    const { resourceDetail, filters } = entryAndDepartureReportState;

    const isEmployeeVehicle = resourceType === 'VEH';

    const isAPerson = ['VIS', 'EMP'].some(type => type === resourceType);

    const isGuard = Number(getDataUserByKey('access_profile_id')) === 3;

    const haveAccessBuildings = isGuard ? getUserBuilding().buildingDescription !== t('NO_BUILDING') : getTenantInfoByKey('is_building');

    const haveEquipmentTypes = getTenantInfoByKey('has_enabled_equipments_type');

    const editStateInitial = {
        active: false,
        movementType: ''
    }
    const msgEditAlertInitial = {
        active: false,
        msg: ''
    }

    const [edit, setEdit] = useState(editStateInitial);
    const [dateMovement, setDateMovement] = useState();
    const [timeMovement, setTimeMovement] = useState();
    const [msgEditAlert, SetmsgEditAlert] = useState(msgEditAlertInitial);

    const isEntry = type === 'ENTRY';

    const title = isEntry ? t('ENTRY') : t('DEPARTURE');
    const imgIcon = isEntry ? 'entryDoor-black.svg' : 'departureDoor-black.svg';
    const movementType = isEntry ? resourceDetail?.checkin_movement : resourceDetail?.checkout_movement;
    const detailUpdated = isEntry ? resourceDetail?.access_updated : resourceDetail?.egress_updated;

    const vehicles = isEntry ? resourceDetail?.vehiclesIn : resourceDetail?.vehiclesOut;
    const persons = isEntry ? resourceDetail?.personIn : resourceDetail?.personOut;
    const equipmentsAccess = resourceDetail?.equipments_access;

    const visitTypes = ['VIS', 'VEHVIS'];
    const userPermissions = getDataUserByKey('permissions');
    const permissionToEdit = userPermissions?.find((item) => item.access_permission_id === 4);

    const { systemDate } = useGetDateAndHour({ enabled: edit.active });

    const checkMaxOrMinDate = (type) => {
        const oppositeTypeMov = !isEntry ? resourceDetail?.checkin_movement : resourceDetail?.checkout_movement;
        if (oppositeTypeMov) {
            const [date, time] = isoToDate(oppositeTypeMov.date_movement, 'YYYYMMDD', '-').split('T');
            const typeValues = { date, time }
            return typeValues[type]
        }
        return '';
    }

    const handleActivateToEdit = (movementType) => {
        const [date, time] = isoToDate(movementType.date_movement, 'YYYYMMDD', '-').split('T');
        setEdit({
            active: !edit.active,
            movementType
        });
        setDateMovement(date);
        setTimeMovement(time)
    }

    const handleCancelEdit = () => {
        setEdit(editStateInitial);
        setDateMovement(null);
        setTimeMovement(null);
        SetmsgEditAlert(msgEditAlertInitial);
    }

    const isDisabledEdit = () => {
        if (!movementType) {
            return true
        }

        const [currentDate, currentTime] = systemDate.split(' ');

        const dateWasEntered = dateMovement && timeMovement;
        
        const dateIsLaterThanCurrentDate = new Date(`${dateMovement}T${timeMovement}`).getTime() > new Date(`${currentDate}T${currentTime}`).getTime();
        
        return !dateWasEntered || dateIsLaterThanCurrentDate;

    }

    const handleDateChange = (e) => {
        setDateMovement(e);
    };

    const handleTimeChange = (e) => {
        setTimeMovement(e.target.value);
    };

    const handleToEdit = async () => {
        const dateString = dateMovement.replaceAll('-', '');
        const timeString = timeMovement.slice(0, 5).replaceAll(':', '');

        const dateTosend = dateString + timeString + '00';

        const values = {
            access_movement_id: movementType.access_movement_id,
            date: dateTosend
        }

        const { ok, message } = await editEntryOrDeparture(values);

        if (ok === true) {
            setEdit({
                ...edit,
                active: !edit.active,
            });

            //refresh table information
            await getEntriesAndDepartures(filters);
            //refresh modal information
            return setEdited(true);
        }

        SetmsgEditAlert({
            active: true,
            msg: message
        })

        setTimeout(() => {
            setEdit({
                ...edit,
                active: !edit.active,
            });
            SetmsgEditAlert({ ...msgEditAlert, active: false });
        }, 3000);

    }
    /* const handleCloseAlert = (e) => {
        setEdit({
            ...edit,
            active: !edit.active,
        });
        SetmsgEditAlert({ ...msgEditAlert, active: false });
    }; */

    return (
        <>
            {
                Object.keys(resourceDetail).length === 0 ?
                    <div className='d-flex justify-content-center align-items-center'>
                        <Spinner />
                    </div>

                    :

                    <div className='p-3 d-flex flex-column justify-content-between h-100'>
                        <div>
                            <div className='d-flex align-items-center'>
                                <img src={require(`../../../assets/icons/${imgIcon}`)} alt="entryIcon" />
                                <p className='m-0 ms-1' style={{ fontSize: '20px', color: 'var(--gray-950)' }}>{title}</p>
                            </div>
                            {
                                msgEditAlert.active ?
                                    <div className='d-flex justify-content-center align-items-center'>
                                        <Alert color={'danger'} /* toggle={handleCloseAlert} */>{msgEditAlert.msg}</Alert>
                                    </div>
                                    :
                                    null
                            }
                            <div className='d-flex flex-column gap-2 justify-content-between mb-3 mt-3'>
                                <div className='d-flex flex-wrap'>
                                    <div className='me-3'>
                                        <p className='m-0 resDetail-entryDeparture-title'>{t('DATE')}</p>
                                        {
                                            edit.active && !msgEditAlert.active ?
                                                <CustomDateInput
                                                    value={dateMovement}
                                                    onChange={handleDateChange}
                                                    maxDate={isEntry ? checkMaxOrMinDate('date') : null}
                                                    minDate={!isEntry ? checkMaxOrMinDate('date') : null}
                                                />
                                                :
                                                <p className='m-0 resDetail-entryDeparture-subtitle'>{movementType?.date_movement ? getDateOrTimeToReport(movementType.date_movement, 'DATE', false) : '-'}</p>

                                        }
                                    </div>

                                    <div>
                                        <p className='m-0 resDetail-entryDeparture-title'>{t('HOUR')}</p>

                                        {
                                            edit.active && !msgEditAlert.active ?
                                                <input
                                                    type="time"
                                                    className="form-control"
                                                    value={timeMovement}
                                                    max={isEntry ? checkMaxOrMinDate('time') : null}
                                                    min={!isEntry ? checkMaxOrMinDate('time') : null}
                                                    onChange={handleTimeChange}
                                                />
                                                :
                                                <p className='m-0 resDetail-entryDeparture-subtitle'>{movementType?.date_movement ? getDateOrTimeToReport(movementType.date_movement, 'TIME', false) : '-'}</p>
                                        }
                                    </div>

                                    <div className='ms-3  d-flex justify-content-center align-items-end'>
                                        {permissionToEdit && movementType && !msgEditAlert.active ?
                                            edit.active ?
                                                <div className='gap-2 d-flex justify-content-center align-items-center'>

                                                    <button className='btn p-2 border-0' disabled={isDisabledEdit()} onClick={handleToEdit}>
                                                        <i className='fa-solid fa-check-circle' type='button' style={{ color: isDisabledEdit() ? '#ccc' : '#639af3' }}></i>
                                                    </button>

                                                    <button className='btn p-0 border-0' onClick={handleCancelEdit}>
                                                        <i className='fa-solid fa-times-circle' type='button' style={{ color: '#dc3545' }}></i>
                                                    </button>
                                                </div>
                                                :
                                                <i className='fa-solid fa-pen-to-square mb-2' type='button' style={{ color: '#639af3' }} onClick={() => handleActivateToEdit(movementType)}></i>
                                            :
                                            null
                                        }

                                        {movementType ?
                                            msgEditAlert.active ?
                                                <img type='button' src={errorIcon} alt="error Icon" /* onClick={handleCloseAlert} */ />
                                                :
                                                null
                                            :
                                            null
                                        }
                                    </div>
                                </div>

                                <div >
                                    <div>
                                        <p className='m-0 resDetail-entryDeparture-title d-inline'>
                                            {t('USER_NAME')}
                                        </p>

                                    </div>
                                    <p className='m-0 resDetail-entryDeparture-subtitle'>
                                        {movementType?.user_created ? movementType.user_created : '-'}
                                    </p>
                                </div>
                                {detailUpdated && <div >
                                    <div>
                                        <p className='m-0 resDetail-entryDeparture-title d-inline'>
                                            {t('EDITED_BY')}
                                        </p>
                                        {(havePermission(22) && detailUpdated) && (
                                            <>
                                                <CustomTooltip
                                                    target={title}
                                                    placement={'top'}
                                                    text={`${t(`THE_${isEntry ? 'ACCESS' : 'EXIT'}_RECORD_WAS_MODIFY_AT_THE_DATE`)} ${isoToDate(detailUpdated).replaceAll('T', ' ').slice(0, 16)}`}
                                                />
                                                <i
                                                    id={title}
                                                    className="fa-solid fa-circle-info ps-2"
                                                    style={{ color: '#var(--gray-950)' }}
                                                >
                                                </i>
                                            </>
                                        )}
                                    </div>

                                    {detailUpdated && <p className='m-0 resDetail-entryDeparture-subtitle'>
                                        {movementType?.user_updated ? movementType.user_updated : movementType.user_created}
                                    </p>}

                                </div>}

                            </div>
                        </div>
                        <div className='d-flex flex-column h-100 gap-1'>

                            {
                                vehicles?.length ?
                                    vehicles.map((vehicle, i) => {

                                        return (
                                            <div key={i} className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex flex-wrap'>
                                                    <div className='me-2 d-flex align-items-center' style={{ borderRadius: '5px' }}>
                                                        <img src={carIcon} alt="icon" className='p-2' />
                                                    </div>
                                                    <div>
                                                        <p className='m-0' style={{ fontSize: '14px', fontWeight: '600', color: '#484A51' }}>{vehicle.resource_name ? vehicle.resource_name : '-'}</p>
                                                        <p className='m-0 resDetail-entryDeparture-title'>{vehicle.resource_natural_id ? vehicle.resource_natural_id : '-'}</p>
                                                        <p className='m-0' style={{ fontSize: '12px', fontWeight: '500', color: '#616161;' }}>{vehicle.contractor_name ? vehicle.contractor_name : '-'}</p>

                                                    </div>
                                                </div>

                                                {!visitTypes.includes(resourceType) ?
                                                    <div>
                                                        <div className={`tablet-color ${colorAptitude(vehicle.resource_status)}`} style={{ color: '#ffff' }}>
                                                            <p className='m-0 text-center'>{translationApt('aptitude_status', vehicle.resource_status)}</p>
                                                        </div>
                                                    </div>
                                                    : null
                                                }

                                            </div>
                                        )
                                    })

                                    :
                                    null
                            }

                            {
                                persons?.length ?
                                    persons.map((person, i) => {

                                        return (
                                            <div key={i} className='mt-1 d-flex align-items-center justify-content-between'>
                                                <div className='d-flex'>
                                                    <div className='me-2 d-flex align-items-center' style={{ borderRadius: '5px' }}>
                                                        <img src={person.resource_type === 'EMP' ? empIcon : visitIcon} alt="icon" className='p-2' />
                                                    </div>
                                                    <div>
                                                        <p className='m-0' style={{ fontSize: '14px', fontWeight: '600', color: '#484A51' }}>

                                                            {
                                                                person.resource_name && person.resource_last_name ?
                                                                    `${person.resource_name} ${person.resource_last_name}`
                                                                    :
                                                                    person.resource_name
                                                            }

                                                        </p>
                                                        <p className='m-0 resDetail-entryDeparture-title'>{person.resource_natural_id ? person.resource_natural_id : '-'}</p>
                                                    </div>
                                                </div>

                                                {!visitTypes.includes(resourceType) ?
                                                    <div>
                                                        <div className={`tablet-color ${colorAptitude(person.resource_status)}`} style={{ color: '#ffff' }}>
                                                            <p className='m-0 text-center'>{translationApt('aptitude_status', person.resource_status)}</p>
                                                        </div>
                                                    </div>
                                                    : null
                                                }

                                            </div>
                                        )
                                    })

                                    :
                                    null
                            }
                            {(isEntry && equipmentsAccess?.length > 0) && (
                                equipmentsAccess.map(equipmentsAccess =>
                                    <div
                                        key={equipmentsAccess.equipment_detail}
                                        className='d-flex align-items-center justify-content-between'
                                    >
                                        <div className='d-flex flex-wrap'>
                                            <div
                                                className='me-2 d-flex align-items-center'
                                                style={{
                                                    backgroundColor: 'var(--gray-800)',
                                                    borderRadius: '5px'
                                                }}
                                            >

                                                <img
                                                    src={equipmentIcon}
                                                    alt="equipmentIcon"
                                                    style={{
                                                        width: '56px',
                                                        height: '56px'
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <p
                                                    className='m-0'
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: '600',
                                                        color: '#484A51'
                                                    }}
                                                >
                                                    {equipmentsAccess.equipment_description}
                                                </p>
                                                <p className='m-0 resDetail-entryDeparture-title'>
                                                    {equipmentsAccess.equipment_detail}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            )}

                            {(isEntry && isAPerson && equipmentsAccess === null && haveEquipmentTypes) && (
                                <div className='d-flex gap-2 align-items-center'>
                                    <img
                                        src={equipmentIcon}
                                        alt="equipmentIcon"
                                        style={{
                                            width: '56px',
                                            height: '56px'
                                        }}
                                    />
                                    <p
                                        className='m-0'
                                        style={{
                                            fontSize: '14px',
                                            fontWeight: '600',
                                            color: '#484A51'
                                        }}
                                    >
                                        {t('NO_EQUIPMENT')}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div>
                            {(haveAccessBuildings && isEmployeeVehicle) && (
                                <div className='mt-3'>
                                    <p className='m-0 resDetail-entryDeparture-title' >{getTenantInfoByKey('area_name')}</p>
                                    <p className='m-0 resDetail-entryDeparture-subtitle'>
                                        {movementType !== null ? (movementType.area ? movementType.area : t('FREE_ACCESS_AREA')) : '-'}
                                    </p>
                                </div>
                            )}

                            <div className='mt-3'>
                                <p className='m-0 resDetail-entryDeparture-title' >{t('OBSERVATIONS')}</p>
                                <p className='m-0 resDetail-entryDeparture-subtitle text-break'>{movementType?.observations ? movementType.observations : '-'}</p>
                            </div>
                        </div>

                    </div >
            }

        </>
    )
}
